import { Dragger } from './Dragger';
/**
 * Dragger that detects direction
 */
export class DraggerDirection extends Dragger {
    _getDefaultProp() {
        return Object.assign(Object.assign({}, super._getDefaultProp()), { min: 75 });
    }
    /**
     * Event on drag end
     */
    _handleEnd(e) {
        const res = super._handleEnd(e);
        if (!res) {
            return res;
        }
        const evt = this._normalizeEvent(e);
        const { startCoords } = this;
        const min = Math.abs(this.prop.min);
        // up
        if (startCoords.y > evt.y
            && Math.abs(evt.y - startCoords.y) >= min) {
            this.callbacks.tbt('up', false);
        }
        // down
        if (startCoords.y < evt.y
            && Math.abs(evt.y - startCoords.y) >= min) {
            this.callbacks.tbt('down', false);
        }
        // left
        if (startCoords.x > evt.x
            && Math.abs(evt.x - startCoords.x) >= min) {
            this.callbacks.tbt('left', false);
        }
        // right
        if (startCoords.x < evt.x
            && Math.abs(evt.x - startCoords.x) >= min) {
            this.callbacks.tbt('right', false);
        }
        return true;
    }
}
